import {
	DeleteRequest,
	ModifyRequest
} from "utils/fetch/FetchRequest";
import { AuthenticationTokens, Login } from "./AuthenticationTypes";

const ENDPOINT = "/api/auth";

export default class AuthenticationClient {
	public static login(
		data: Login
	): ModifyRequest<Login, AuthenticationTokens> {
		return {
			operation: "POST",
			url: `${ENDPOINT}/login`,
			unauthenticated: true,
			body: data,
			statusCode: 200,
			callback: response => response.json()
		};
	}

	public static logout(token: string): DeleteRequest<void> {
		return {
			operation: "DELETE",
			url: `${ENDPOINT}/logout/${token}`,
			statusCode: 200,
			callback: () => Promise.resolve()
		};
	}

	public static logoutAll(): DeleteRequest<void> {
		return {
			operation: "DELETE",
			url: `${ENDPOINT}/logout-all`,
			statusCode: 200,
			callback: () => Promise.resolve()
		};
	}
}
